import React, {useState} from 'react';
import {Text,View,ActivityIndicator} from 'react-native';
import { AntDesign } from '@expo/vector-icons'; 



export default function dadosbancarios({route,navigation}){
    const [loading, setLoading] = useState(true);
    const [Dados, setDados] = React.useState([]);
    const [Agencia, setAgecia] = React.useState([]);
    const [Conta, setConta] = React.useState([]);
    const [tipoconta, setTipo] = React.useState([]);
    const [Cpf, setCpf] = React.useState([]);
    const [Nome, setNome] = React.useState([]);
    const [operacao, setOperacao] = React.useState([]);
    
   
var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/dadosbancarios.php';
var headers={
   'Accept':'application/json',
   'Content-Type':'application.json',
   'Access-Control-Allow-Methods': 'POST',
   'Access-Control-Allow-Origin':'*',
   'crossDomain': 'true',
   'Host': 'https://emprestimoimperion.com/composer/controller/api/dadosbancarios.php',
   'Origin': 'https://emprestimoimperion.com',
   'credentials': 'same-origin',
   'Access-Control-Allow-Credentials': 'true'
   
    };
   /*'crossDomain': 'true',*/
    var Data={       
    id:route.params.userid,
    token:route.params.id,
    };

    fetch(validatinoApi,
    {
    method:'POST',
    headers:headers,
    body:JSON.stringify(Data)
    }).then((response)=>response.json())
    .then((response)=>{
    if(response.statusCode==200){
       setDados(response.banco)
       setAgecia(response.agencia)
       setConta(response.conta)
       setCpf(response.cpf)
       setNome(response.nome)
       setTipo(response.tipoconta)
       setOperacao(response.operacao)
       setLoading(false);
    }else{
    setLoading(false);
    alert('Algo errado');
    } 
    }).catch((error)=>{
    console.log(error);
    setLoading(false);
    });

return(
<View style={{backgroundColor:'#01150E',height:'100%'}}>
<View style={{alignItems:'center'}}>
<Text style={{fontSize:20,color:'white',margin:10}}>Dados Bancário</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Dados}</Text>
<Text style={{color:'white',margin:10}}>Banco</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Agencia}</Text>
<Text style={{color:'white',margin:10}}>Agencia</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Conta}</Text>
{loading?(<ActivityIndicator color="white" size={40} />) : null}
<Text style={{color:'white',margin:10}}>Conta</Text>
</View>

<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{tipoconta}</Text>
<Text style={{color:'white',margin:10}}>Tipo</Text>
</View>

<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{operacao}</Text>
<Text style={{color:'white',margin:10}}>Operação</Text>
</View>

<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Cpf}</Text>
<Text style={{color:'white',margin:10}}>CPF</Text>
</View>
<View style={{margin:20,borderBottomWidth:1,borderColor:'white'}}><Text style={{color:'white',fontSize:15}}>{Nome}</Text>
<Text style={{color:'white',margin:10}}>Nome</Text>
</View>
<View style={{alignItems: 'flex-end',margin:20}}>
<AntDesign name="edit" size={40} color="white"  onPress = {() => {navigation.navigate('Cadastro_Bancario',{id:route.params.id,userid:route.params.userid})}}/>
</View>
</View>
);

}